module.exports = __webpack_public_path__ + "static/media/info-hover.988ea1bf.png";